<template>
  <div class="container-fluid px-4">
    <div class="row">
      <div class="col-9">
        <div class="row align-items-center">
          <div class="col-8">
            <h2 class="h2 e-text-red">Accident / Incident Yearly Report</h2>
          </div>
          <div class="col-4">
            <select name="" id="" class="form-control form-control-sm" v-model="office_id">
              <option :value="null"> ALL BRANCH OFFICE</option>
              <option :value="office.id" v-for="office in mngmntOfficeKeys ">
                {{office.name ? office.name.toUpperCase() : ''}}
              </option>
            </select>
          </div>
        </div>
        <div class="row mb-2 justify-content-sm-between">
          <div class="col-auto">
            <nav class="navbar navbar-expand-lg mt-2" id="ModelNav">
              <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav"
                      aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
                <ul class="navbar-nav">
                  <li class="nav-item" @click="requestNewChart('number_of_report', office_id)">
                    <router-link
                      class="nav-link" :to="{ name: $route.name, params : {
                  chart_module : 'number_of_report'
                }}">
                      <span style="height: 100%">Number of Report</span>
                    </router-link>
                  </li>
                  <li class="nav-item" @click="requestNewChart('number_of_delay', office_id)">
                    <router-link
                      class="nav-link" :to="{ name: $route.name, params : {
                  chart_module : 'number_of_delay'
                }}">
                      <span>Number Of Delay</span>
                    </router-link>
                  </li>
                  <li class="nav-item" @click="requestNewChart('delay_hours', office_id)">
                    <router-link
                      class="nav-link" :to="{ name: $route.name, params : {
                  chart_module : 'delay_hours'
                }}">
                  <span>Delay Hours</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link" :to="{ name: $route.name, params : {
                  chart_module : 'vessel_loss'
                }}">
                  <span>Loss</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link" :to="{ name: $route.name, params : {
                  chart_module : 'safety_and_health'
                }}">
                      <span>Safety and Health</span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>

      <div class="col-auto pt-2 hide-download-csv" v-if="[
        'vessel_loss',
        'safety_and_health',
        ]
      .includes($route.params.chart_module) === false && ['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
        <button class="e-btn-primary btn btn-dark btn-sm force-white-all" :disabled="hasEnabledSeries" @click.prevent="generateCsv"><font-awesome-icon icon="download" class="mr-2"></font-awesome-icon>DOWNLOAD CSV</button>
      </div>
      <div class="col-12 pt-2 hide-download-csv-two" v-if="[
        'vessel_loss',
        'safety_and_health',
        ]
      .includes($route.params.chart_module) === false && ['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
        <button class="e-btn-primary btn btn-dark btn-sm force-white-all float-right" :disabled="hasEnabledSeries" @click.prevent="generateCsv"><font-awesome-icon icon="download" class="mr-2"></font-awesome-icon>DOWNLOAD CSV</button>
      </div>
    </div>

        <div v-if="$route.params.chart_module === 'safety_and_health'">
          <safety-and-health/>

          <accident-incident-yearly-report-graph
            :key="$route.params.chart_module"
          />
        </div>
        <div v-else-if="$route.params.chart_module === 'vessel_loss'">
          <accident-incident-vessel-loss/>
        </div>
        <div v-else>
          <div v-if="loading">
            <app-loading></app-loading>
          </div>
          <template v-else>
<!--            FOR FILTERS (CURRENTLY DISABLED)-->

<!--            <div class="row">-->
<!--              <div class="col-12 pt-3 d-flex align-items-center">-->
<!--                <span class="font-weight-bold text-uppercase h6" style="color: black">Filters:</span>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="row">-->
<!--              <div class="col-10">-->
<!--                <div class="row">-->
<!--                  <div class="col-12 pb-1">-->
<!--                    <select style="font-size: 8pt;" name="" id="" class="form-control form-control-sm text-uppercase"-->
<!--                            @change="modifyEventCode('event.event_one_id',$event)"-->
<!--                            v-model="event.event_one_id">-->
<!--                      <option :value="null" disabled>&#45;&#45; Select Event Code 1 &#45;&#45;</option>-->
<!--                      <option v-for="event in eventOneKeys" :key="event.id" :value="event.id">-->
<!--                        {{event.code}}) {{ event.name }}-->
<!--                      </option>-->
<!--                    </select>-->
<!--                  </div>-->

<!--                  <div class="col-12 pb-1">-->
<!--                    <select style="font-size: 8pt;" name="" id="" class="form-control form-control-sm text-uppercase"-->
<!--                            @change="modifyEventCode('event.event_two_id',$event)"-->
<!--                            v-model="event.event_two_id"-->
<!--                            :disabled="!event.event_one_id">-->
<!--                      <option :value="null" disabled>&#45;&#45; Select Event Code 2 &#45;&#45;</option>-->
<!--                      <option v-for="event in eventTwoKeys" :key="event.id" :value="event.id">-->
<!--                        {{event.code}}) {{ event.name }}-->
<!--                      </option>-->
<!--                    </select>-->
<!--                  </div>-->

<!--                  <div class="col-12 pb-1">-->
<!--                    <select style="font-size: 8pt;" name="" id="" class="form-control form-control-sm text-uppercase"-->
<!--                            @change="modifyEventCode('event.event_three_id',$event)"-->
<!--                            v-model="event.event_three_id"-->
<!--                            :disabled="!event.event_two_id">-->
<!--                      <option :value="null" disabled>&#45;&#45; Select Event Code 3 &#45;&#45;</option>-->
<!--                      <option v-for="event in eventThreeKeys" :key="event.id" :value="event.id">-->
<!--                        {{event.code}}) {{ event.name }}-->
<!--                      </option>-->
<!--                    </select>-->
<!--                  </div>-->

<!--                  <div class="col-12 pb-3">-->
<!--                    <select style="font-size: 8pt;" name="" id="" class="form-control form-control-sm text-uppercase"-->
<!--                            @change="modifyEventCode('event.event_four_id',$event)"-->
<!--                            v-model="event.event_four_id"-->
<!--                            :disabled="!event.event_three_id">-->
<!--                      <option :value="null" disabled>&#45;&#45; Select Event Code 4 &#45;&#45;</option>-->
<!--                      <option v-for="event in eventFourKeys" :key="event.id" :value="event.id">-->
<!--                        {{event.code}}) {{ event.name }}-->
<!--                      </option>-->
<!--                    </select>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-2 pl-0">-->
<!--                <div class="row">-->
<!--                  <div class="col-12">-->
<!--                    <button class="e-btn e-btn-green text-uppercase font-weight-bold w-100 p-2" @click="generateChart">Generate <br>Graph</button>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="row mt-2">-->
<!--                  <div class="col-12">-->
<!--                    <button class="e-btn e-btn-blue-gray text-uppercase font-weight-bold w-100 p-2" @click="clearChartFilters">Clear <br>Filters</button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

            <div v-if="loadingChart">
              <app-loading></app-loading>
            </div>
            <template v-else>
              <div class="card shadow-sm mb-4">
                <div class="card-body pb-2">
                  <div>
                    <!--                  <ai-yearly-chart :category-object="aiChartData" :years="years" :series="chartInfo" :office="office_id" :categories="chartCategories" :event-selected="event"></ai-yearly-chart>-->
                    <AccidentIncidentEventChart ref="accidentIncidentEventChartRef" :data="aiChartData" :events-filter="event" :years="years" :office="office_id" @series-updated="hasEnabledSeries = $event"></AccidentIncidentEventChart>
                  </div>
                </div>
              </div>
              <div class="card shadow-sm mb-4">
                <div class="card-body">
                  <div class="row no-gutters">
                    <div class="col">
                      <h5 class="e-text-red-light-1">Accident / Incident Data {{ $route.params.chart_module === 'delay_hours' ? 'via Hours' : ''}}</h5>
                    </div>
                    <div class="col-2 col-md-auto">
                      <div class="float-right text-right ml-2">
                        <AISummary
                          :key="$route.params.chart_module"
                          :html-element-id="htmlElementId"
                          :question=AiSummaryQuestion
                          :summarizing-text="summarizingText"
                          :data="dataWithYearlySummary"
                        />
                      </div>
                    </div>
                  </div>
                  <ai-yearly-table :data="aiChartData" :years="years"></ai-yearly-table>
                </div>
              </div>
              <div class="card shadow-sm mb-4" style="background-color: white; position: absolute; width: 100%; top: 0; left: -100000px;">
                <!--        <div class="card shadow-sm mb-4" style="background-color: white">-->
                <div class="card-body" :id="htmlElementId">
                  <div class="row no-gutters">
                    <div class="col">
                      <h5 class="e-text-red-light-1">Accident / Incident Data {{ $route.params.chart_module === 'delay_hours' ? 'via Hours' : ''}}</h5>
                    </div>
                  </div>

                  <div  style="background-color: white">
                    <ai-yearly-table :for-ai-summary=true :font-size="'20px'" :data="aiChartData" :years="years"></ai-yearly-table>
                  </div>

                </div>
              </div>

              <accident-incident-yearly-report-graph
                :key="$route.params.chart_module"
              />
            </template>

          </template>
        </div>



      </div>
      <div class="col-3">
        <h2 class="h2 e-text-red">Reports</h2>
        <div class="card shadow-sm rounded mb-3">
          <div class="card-body">
            <h5 class="e-text-red-light-1">Accident / Incident</h5>
            <template v-if="loading">
              <app-loading></app-loading>
            </template>
            <table class="table mb-1" v-else>
              <tr v-for="airCount in airReportStatusCounts">
                <th>{{airCount.name}}</th>
                <th>{{airCount.count}}</th>
              </tr>
            </table>
          </div>
        </div>
        <div class="card shadow-sm rounded mb-3">
          <div class="card-body">
            <h5 class="e-text-red-light-1">Inspection</h5>
            <h6 class="e-text-red-light-1">PSC Inspection</h6>
            <table class="table mb-1">
              <tr>
                <th>NEW</th>
                <th>0</th>
              </tr>
              <tr>
                <th>OPEN</th>
                <th>0</th>
              </tr>
              <tr>
                <th>READY TO CLOSE</th>
                <th>0</th>
              </tr>
              <tr>
                <th>CLOSED</th>
                <th>0</th>
              </tr>
              <tr class="border-bottom">
                <th>RECORD ONLY</th>
                <th>0</th>
              </tr>
            </table>
            <h6 class="e-text-red-light-1">Rightship Inspection</h6>
            <template v-if="loading">
              <app-loading></app-loading>
            </template>
            <table v-else class="table mb-1">
              <tr v-for="rsCount in rsReportStatusCounts" :key="rsCount.name">
                <th>{{ rsCount.name.toUpperCase() }}</th>
                <th>{{ rsCount.count }}</th>
              </tr>
            </table>
            <!--        <table class="table mb-1">-->
            <!--          <tr>-->
            <!--            <th>NEW</th>-->
            <!--            <th>0</th>-->
            <!--          </tr>-->
            <!--          <tr>-->
            <!--            <th>OPEN</th>-->
            <!--            <th>0</th>-->
            <!--          </tr>-->
            <!--          <tr>-->
            <!--            <th>READY TO CLOSE</th>-->
            <!--            <th>0</th>-->
            <!--          </tr>-->
            <!--          <tr>-->
            <!--            <th>CLOSED</th>-->
            <!--            <th>0</th>-->
            <!--          </tr>-->
            <!--          <tr class="border-bottom">-->
            <!--            <th>RECORD ONLY</th>-->
            <!--            <th>0</th>-->
            <!--          </tr>-->
            <!--        </table>-->
          </div>
        </div>
        <div class="card shadow-sm rounded mb-3">
          <div class="card-body">
            <h5 class="e-text-red-light-1">Audit</h5>
            <table class="table mb-1">
              <tr>
                <th>NEW</th>
                <th>0</th>
              </tr>
              <tr>
                <th>OPEN</th>
                <th>0</th>
              </tr>
              <tr>
                <th>READY TO CLOSE</th>
                <th>0</th>
              </tr>
              <tr>
                <th>CLOSED</th>
                <th>0</th>
              </tr>
              <tr class="border-bottom">
                <th>RECORD ONLY</th>
                <th>0</th>
              </tr>
            </table>
          </div>
        </div>
        <div class="card shadow-sm rounded mb-3">
          <div class="card-body">
            <h5 class="e-text-red-light-1">Master's Review and Improvement</h5>
            <table class="table mb-1">
              <tr>
                <th>NEW</th>
                <th>0</th>
              </tr>
              <tr>
                <th>OPEN</th>
                <th>0</th>
              </tr>
              <tr>
                <th>READY TO CLOSE</th>
                <th>0</th>
              </tr>
              <tr>
                <th>CLOSED</th>
                <th>0</th>
              </tr>
              <tr class="border-bottom">
                <th>RECORD ONLY</th>
                <th>0</th>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccidentIncidentYearlyChart from "@/components/dashboard/accident-incident/AccidentIncidentYearlyChart.vue";
import {mapActions, mapGetters} from "vuex";
import AppLoading from "@/components/elements/AppLoading";
import AccidentIncidentYearlyTable from "@/components/dashboard/accident-incident/AccidentIncidentYearlyTable";
import {permissionMixin} from "@/mixins/permissionMixins";
import {ExcelService} from "@/services/ExcelService";
import {AccidentIncidentDashboardService} from "@/services/AccidentIncidentDashboardService";
import AccidentIncidentEventChart from "@/components/dashboard/accident-incident/AccidentIncidentEventChart.vue";
import SafetyAndHealth from "@/components/dashboard/accident-incident/SafetyAndHealth/SafetyAndHealth.vue";
import AccidentIncidentVesselLoss from "@/components/dashboard/accident-incident/AccidentIncidentVesselLoss.vue";
import AISummary from "@/components/common/AISummary.vue";
import AccidentIncidentYearlyReportGraph
  from "@/components/dashboard/accident-incident/AccidentIncidentYearlyReportGraph.vue";
export default {
  name: 'Dashboard',
  mixins:[permissionMixin],
  data(){
    return {
      event: {
        event_one_id: null,
        event_two_id: null,
        event_three_id: null,
        event_four_id: null,
        chart_module_new: null,
      },
      aiChartData: [],
      loading:false,
      startYear:new Date().toISOString().split("T")[0].split('-')[0] - 5,
      currentYear:new Date().toISOString().split("T")[0].split('-')[0],
      office_id: null,
      hasEnabledSeries: false,
      loadingChart : false
    }
  },
  components: {
    AccidentIncidentYearlyReportGraph,
    AccidentIncidentVesselLoss,
    SafetyAndHealth,
    AISummary,
    AccidentIncidentEventChart,
    'ai-yearly-chart': AccidentIncidentYearlyChart,
    'ai-yearly-table': AccidentIncidentYearlyTable,
    'app-loading' : AppLoading

  },
  methods:{
    ...mapActions(['getVesselTypeKeys','getAirReportStatusCounts','getAccidentCharts','getMngmtOfficeKeys', 'getRsReportStatusCounts', 'getEventOneKeys', 'getEventTwoKeys', 'getEventThreeKeys', 'getEventFourKeys', 'getEventFiveKeys']),
    getChartColor(index){
      const colors=['#bfbfbf','#a6a6a6','#ffd966','#f7caac','#f4b083','#ff0000']
      return colors[index];
    },
    async generateCsv(){
      swal.fire({
        'title': 'GENERATING CSV FILE',
        allowEscapeKey:false,
        allowEnterKey:false,
        allowOutsideClick:false,
      })
      swal.showLoading()
      const activeYears = this.$refs?.accidentIncidentEventChartRef?.enabledSeriesData;
      const yearsPayload = (Array.isArray(activeYears) && activeYears.length > 0) ? activeYears : this.years;
      const params = {
        office_id: this.office_id,
        years: yearsPayload
      };

      if (this.$route?.params?.chart_module === 'delay_hours') {
        params.delay_module = this.$route.params.chart_module;
      }

      if (this.$route?.params?.chart_module === 'number_of_delay') {
        params.delay_module = this.$route.params.chart_module;
      }

      await ExcelService.csv('ACCIDENT INCIDENT', params)
      swal.close();
    },
    async requestNewChart(chartModule, office_id = null) {
      if (chartModule === 'safety_and_health') {
        return;
      }

      this.loadingChart=true;
      let chartParams = {};

      if (office_id !== null) {
        chartParams.office_id = office_id;
        this.event.office_id = office_id;
      }else{
        this.event.office_id = null
      }

      if (chartModule !== 'number_of_report') {
        chartParams.delay_module = this.$route.params.chart_module;
      }

      // await this.getAccidentCharts(chartParams);
      await this.generateChart();
      this.loadingChart=false;
    },
    async generateChart(){
      this.loadingChart = true;
      if(this.$route.params.chart_module !== 'number_of_report'){
        this.event.delay_module = this.$route.params.chart_module;
      }else {
        delete this.event.delay_module;
      }

      const response = await AccidentIncidentDashboardService.getAccidentIncidentChartData(this.event);
      this.aiChartData = response.data;
      this.loadingChart = false;
    },
    async clearChartFilters(){
      this.event.event_one_id = null;
      this.event.event_two_id = null;
      this.event.event_three_id = null;
      this.event.event_four_id = null;
      this.event.office_id = null;
      this.office_id = null;
      await this.generateChart();
    },
    modifyEventCode(key = '', evt) {
      switch (key){
        case 'event.event_one_id':
          this.event.event_one_id = evt.target.value === '' ? null : evt.target.value;
          this.event.event_two_id = null
          this.event.event_three_id = null
          this.event.event_four_id = null
          this.event.event_five_id = null
          this.getEventTwoKeys({event_one_id: this.event.event_one_id})
          break;

        case 'event.event_two_id' :
          this.event.event_two_id = evt.target.value === '' ? null : evt.target.value;
          this.event.event_three_id = null
          this.event.event_four_id = null
          this.event.event_five_id = null
          this.getEventThreeKeys({event_one_id: this.event.event_one_id, event_two_id: this.event.event_two_id})
          break;

        case 'event.event_three_id':
          this.event.event_three_id = evt.target.value === '' ? null : evt.target.value;
          this.event.event_four_id = null
          this.event.event_five_id = null
          this.getEventFourKeys({
            event_one_id: this.event.event_one_id,
            event_two_id: this.event.event_two_id,
            event_three_id: this.event.event_three_id
          })
          if (this.event.event_three_id === 50 || this.eventFourKeys.length > 0) {
            this.getEventFiveKeys({
              event_one_id: this.event.event_one_id,
              event_two_id: this.event.event_two_id,
              event_three_id: this.event.event_three_id
            })
            this.event.event_four_id = null;
          }
          break;
        case 'event.event_four_id':
          this.event.event_four_id = evt.target.value === '' ? null : evt.target.value;
          this.event.event_five_id = null
          this.getEventFiveKeys({ event_one_id: this.event.event_one_id, event_two_id: this.event.event_two_id, event_three_id: this.event.event_three_id })
          break;
      }
    }
  },
  async created() {
    this.loading=true;
    this.office_id=this.isElite() ? null : this.user.management_office_id
    this.getMngmtOfficeKeys({dashboard:true});
    await this.getAirReportStatusCounts({office_id:this.office_id});
    await this.getRsReportStatusCounts({ office_id: this.office_id });
    await this.requestNewChart(this.$route.params.chart_module, this.office_id);
    await this.getEventOneKeys();
    await this.generateChart();
    this.loading=false;
  },
  computed:{
    ...mapGetters(['airReportStatusCounts','airChartCounts','mngmntOfficeKeys','user', 'rsReportStatusCounts','eventOneKeys', 'eventTwoKeys', 'eventThreeKeys', 'eventFourKeys', 'eventFiveKeys',]),
    years(){
      let years=[];
      for (var i = this.startYear; i <= this.currentYear; i++) {
        years.push(i);
      }
      return years;
    },
    chartInfo(){
      let data=[];
      let stats=[];
      for (var i = this.startYear; i <= this.currentYear; i++) {
        const year={
          name:i,
          color: this.getChartColor(this.years.indexOf(i)),
        }
        this.aiChartData.forEach(chart=>{
          data.push(chart.years[i])
        });
        year.data=data
        data=[];
        stats.push(year);
      }
      return stats;
    },
    chartCategories(){
      const categories=[];
      this.aiChartData.forEach(item=>{
        categories.push(item.event)
      });
      return categories;
    },
    AiSummaryQuestion() {
      if (this.$route.params.chart_module === 'number_of_report') {
        return 'summarize table based on number of report';
      }

      if (this.$route.params.chart_module === 'number_of_delay') {
        return 'summarize table based on number of delay';
      }

      if (this.$route.params.chart_module === 'delay_hours') {
        return 'summarize table based on delay hours';
      }
    },
    htmlElementId() {
      if (this.$route.params.chart_module === 'number_of_report') {
        return 'accident-incident-number-of-reports-summary';
      }

      if (this.$route.params.chart_module === 'number_of_delay') {
        return 'accident-incident-number-of-delay-summary';
      }

      if (this.$route.params.chart_module === 'delay_hours') {
        return 'accident-incident-delay-hours-summary';
      }
    },
    summarizingText() {
      if (this.$route.params.chart_module === 'number_of_report') {
        return 'Summarizing Accident Incident Data by Number Of Report...';
      }

      if (this.$route.params.chart_module === 'number_of_delay') {
        return 'Summarizing Accident Incident Data by Number Of Delay...';
      }

      if (this.$route.params.chart_module === 'delay_hours') {
        return 'Summarizing Accident Incident Data by Delay Hours...';
      }
    },
    dataWithYearlySummary() {
      const totals = {};
      const newObject = {};
      this.aiChartData.forEach(item => {
        const itemEvent = item.event;
        newObject[itemEvent] = {}
        Object.entries(item.years).forEach(([year, value]) => {
          totals[year] = ((totals[year] || 0) + parseFloat(value));
          newObject[itemEvent][year] = value;
        });
      });

      Object.keys(totals).forEach(year => {
        totals[year] = parseFloat(totals[year].toFixed(2));
      });
      newObject['SUMMARY'] =  totals;
      return newObject;
    }
  },
  watch:{
    async "office_id"(id){
      await this.requestNewChart(this.$route.params.chart_module, id);
      await this.getAirReportStatusCounts({office_id:id})
      await this.getRsReportStatusCounts({ office_id: id });
    }
  }
}
</script>

<style scoped>
#ModelNav {
  padding: 0;

  li > a {
    padding: .5rem 2rem;
    color: #435464;
    height: 100%;
    text-align: center;
  }

  li:hover a {
    border-bottom: 2px solid #d3313c;
    color: #d3313c;
  }
  .nav-link span {
    font-size: 14px;
  }
}


.router-link-active {
  border-bottom: 2px solid #d3313c;
  color: #d3313c;
  font-weight: bold;

  * {
    color: #d3313c;
  }
}

@media (max-width: 1583px) {
  .hide-download-csv {
    display: none !important;
  }
}

@media (min-width: 1583px) {
  .hide-download-csv-two {
    display: none !important;
  }
}
</style>

